<template>
  <div class="container">
    <div class="top-tool">
      <div class="sort">
        <ul>
          <li>
            搜索关键词---列表只显示有货； 注：(图片信息仅供参考)
          </li>
          <!-- <li>
            <a href=""><i v-show="false" class="el-icon-bottom"></i>销量</a> |
          </li>
          <li>
            <a href=""><i v-show="false" class="el-icon-bottom"></i>库存</a> |
          </li>
          <li>
            <a href=""><i v-show="false" class="el-icon-bottom"></i>价格</a> |
          </li>
          <li>
            <a href=""><i v-show="false" class="el-icon-bottom"></i>更新时间</a>
          </li> -->
        </ul>
      </div>
      <div>
        <!-- 搜索关键词---列表只显示有货； 注：(图片信息仅供参考) -->
      </div>
      <div class="page">
        <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage"
          :page-size="pagesize" layout="total,prev,pager,next" :total="pageTotal">
        </el-pagination>
      </div>
    </div>
    <el-divider></el-divider>
    <el-row :gutter="24">
      <el-col :span="24" v-for="(item, index) in productList" v-bind:key="index" style="margin-left: 5px">
        <el-card shadow="hover">
          <div class="product">
            <el-row :gutter="40">
              <el-col :span="3">
                <div class="img">
                  <el-image style="width: 160px; height: 160px;borser: 1 solide #0000" :src="item.img"></el-image>
                </div>
              </el-col>
              <el-col :span="11" class="product">
                <el-row class="productinfo">
                  <el-col :span="23">
                    <el-tooltip v-if="item.name.length > 29" :content="item.name" placement="top" effect="light">
                      <el-tag effect="dark">
                        <h2>{{ overHidden(item.name, 30) }}</h2>
                      </el-tag>
                    </el-tooltip>
                    <el-tag effect="dark" v-else>
                      <h2>{{ overHidden(item.name, 30) }}</h2>
                    </el-tag>
                  </el-col>
                </el-row>
                <el-row class="productinfo">
                  <el-col :span="22">
                    <el-tooltip :content="item.description" placement="top" effect="light">
                      <span>简介：{{ overHidden(item.description, 200) }}</span>
                    </el-tooltip>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="7" class="product">
                <el-row class="productinfo">
                  <el-col><b>出版社</b>：{{ item.providerName }} </el-col>
                </el-row>
                <el-row class="productinfo">
                  <el-col :span="11"><b>ISBN</b>：{{ item.sn }}</el-col>
                  <el-col :span="13"><b>作者</b>：{{ item.author }} </el-col>
                </el-row>
                <el-row class="productinfo">
                  <el-col :span="11">
                    <b>出版时间</b>：{{ item.providerTime }}
                  </el-col>
                  <el-col :span="13">
                    <b>更新时间</b>：{{ item.updateTime }}
                  </el-col>
                </el-row>
                <el-row class="productinfo">
                  <el-col :span="11">
                    <b>定价</b>：<span class="oldprice">￥{{ item.marketPrice }}</span>
                  </el-col>
                  <el-col :span="13">
                    <b>更多</b>：{{ item.statusBuff }}条
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="2">
                <el-row type="flex">
                  <el-col :span="4">
                    <el-button style="width: 131px !important;" type="primary">库存：{{ item.stock }}
                    </el-button>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col></el-col>
                </el-row>
                <el-row>
                  <el-col></el-col>
                </el-row>
                <el-row>
                  <el-col></el-col>
                </el-row>
                <el-row type="flex">
                  <el-col :span="4">
                    <el-button type="primary" icon="el-icon-shopping-cart-2" @click="showStockList(item)">加入购物车
                    </el-button>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </el-col>
      <el-empty v-if="productList.length < 1" description="搜索不到匹配的图书"></el-empty>
    </el-row>
    <!--显示的内容-->
    <el-divider></el-divider>
    <div>
      <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize"
        layout="total,prev,pager,next" :total="pageTotal">
      </el-pagination>
    </div>
    <el-dialog width="96%" :visible.sync="dialogTableVisible">
      <el-table :data="gridData" stripe max-height="460" @selection-change="handleSelectionChange">
        <el-table-column property="warehouseUserName" label="供应商" width="100">
          <span slot-scope="scope">
            {{ scope.row.warehouseUserName }}
          </span>
        </el-table-column>
        <el-table-column property="productName" label="图书名称"></el-table-column>
        <el-table-column property="providerName" label="出版社" min-width="20"></el-table-column>
        <el-table-column property="providerTime" label="出版时间" width="100"></el-table-column>
        <el-table-column property="marketPrice" label="定价" width="90"></el-table-column>
        <el-table-column property="discount" label="折扣" width="80"></el-table-column>
        <el-table-column label="折扣价" width="90">
          <template slot-scope="scope">
            {{ scope.row.shopPrice.toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column property="productNum" width="100" label="库存">
          <template slot-scope="scope">
            <el-tag type="primary" disable-transitions>{{
              scope.row.productNum
              }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column property="updateTime" label="更新时间" width="100"></el-table-column>
        <el-table-column property="supplierCapability" label="拣货总量/销售总量" width="140"></el-table-column>
        <el-table-column width="120" label="购买数量">
          <template slot-scope="scope">
            <div class="el-input">
              <input type="text" @input="bookAmountChange($event, scope.row)" v-model="scope.row.defaultStock"
                class="el-input__inner" />
              <div class="quick-button">
                <i class="border el-icon-arrow-up" @click="addAmountCount(scope.row)"></i>
                <i class="border el-icon-arrow-down" @click="subtractAmountCount(scope.row)"></i>
              </div>
            </div>
          </template>
        </el-table-column>


        <el-table-column width="100" label="购物车">
          <template slot-scope="scope">
            <el-button type="primary" @click="addCartOne(scope.row)">+</el-button>
          </template>
        </el-table-column>



      </el-table>
      <span slot="title" class="dialog-title">
        {{ dialogTitle }}
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <el-button type="primary" @click="addCartAll">全部加入购物车</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getAction, postAction } from "../../api/index";
import { mapGetters } from "vuex";
export default {
  name: "productList",
  data() {
    return {
      activeName: "1",
      Product: {}, //商品信息
      bookcount: 1,
      showModal: false,
      currentPage: 1, // 当前页码
      pagesize: 20, // 每页显示的行数
      pageTotal: 0,
      productList: [], //商品信息
      queryParam: {
        sn: "",
        bookCategory: "",
        providerName: "",
        name: "",
        author: "",
        sold: 0,
        ishot: 0,
        isnew: 0,
        clickCount: 0,
        keywords: "", //搜索全部条件的
      },
      url: {
        queryProductsList: "/products/queryProductsList",
        addCart: "/cart/addcart",
        queryProductsStockListBySn: "/products/queryProductsStockListBySn",
        queryCartList: "/cart/queryCartList",
      },
      loading: false,
      gridData: [],
      dialogTitle: "123",
      dialogTableVisible: false,
      multipleSelection: [],
    };
  },
  mounted() {},
  activated() {},
  created() {
    if (this.$route.params.selectval === "2") {
      this.queryParam.name = this.$route.params.inputval;
    } else if (this.$route.params.selectval === "3") {
      this.queryParam.author = this.$route.params.inputval;
    } else if (this.$route.params.selectval === "4") {
      this.queryParam.sn = this.$route.params.inputval;
    } else if (this.$route.params.selectval === "5") {
      this.queryParam.providerName = this.$route.params.inputval;
    } else {
      this.queryParam.keywords = this.$route.params.inputval;
    }
    if (
      this.$route.params.selectval === null ||
      this.$route.params.selectval === undefined
    ) {
      //根据图书分类查询
      this.queryParam.bookCategory = this.$route.params.inputval;
    }
    this.getGoodsList(1, this.queryParam);
  },
  methods: {
    handleClick() {
      // tab页切换方法
      console.log("activeName :>> ", this.activeName);
      if (this.activeName === "1") {
        //按照销量倒序排列
        this.queryParam.sold = 1;
        this.queryParam.ishot = 0;
        this.queryParam.isnew = 0;
        this.queryParam.clickCount = 0;
      }
      if (this.activeName === "2") {
        //推荐图书查询
        this.queryParam.sold = 0;
        this.queryParam.ishot = 1;
        this.queryParam.isnew = 0;
        this.queryParam.clickCount = 0;
      }
      if (this.activeName === "3") {
        //新品
        this.queryParam.sold = 0;
        this.queryParam.ishot = 0;
        this.queryParam.isnew = 1;
        this.queryParam.clickCount = 0;
      }
      if (this.activeName === "4") {
        //点击量查询
        this.queryParam.sold = 0;
        this.queryParam.ishot = 0;
        this.queryParam.isnew = 0;
        this.queryParam.clickCount = 1;
      }
      this.currentPage = 1;
      this.getGoodsList(1, this.queryParam);
    },
    getGoodsList(page, queryParam) {
      this.loading = true;
      const that = this
      getAction(this.url.queryProductsList, {
        pageNo: page,
        pageSize: that.pagesize,
        sn: queryParam.sn,
        bookCategory: queryParam.bookCategory,
        providerName: queryParam.providerName,
        keywords: queryParam.keywords,
        name: queryParam.name,
        author: queryParam.author,
        sold: queryParam.sold,
        isHot: queryParam.ishot,
        isNew: queryParam.isnew,
        clickCount: queryParam.clickCount,
      })
        .then((res) => {
          if (res.data.success) {
            this.productList = res.data.result.records;
            this.pageTotal = res.data.result.total;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //加入购物车
    addCartAll() {
      console.log("addCart======", this.gridData);
      this.addCart(this.gridData,'all');
    },
    addCartOne(row){
      this.addCart([row],'one');
    },
    addCart(rowList, addFlag) {
      const that = this
      that.$store.commit("hasLogin");
      if (that.isNaName) {
        that.$message({message: "请先登录！", type: "warning",});
        that.$router.push("/login");
        return;
      }
      let params = [];
      if (rowList.length > 0) {
        let storeCartList = that.$store.state.shopCart
        for (let i = 0; i < rowList.length; i++) {

          // 在弹层的购物车中加入违禁书判断
          if (rowList[i].isBan == 0) {
            let whName = rowList[i].warehouseUserName;
            this.$message.error("[" + whName + "]" + "【" + rowList[i].productName + "】" + "为违禁图书，不能购买！");
            return;
          }

          if (rowList[i].defaultStock > 0) {
            // 校验库存是否已超过真实库存。
            if (storeCartList && storeCartList.length > 0) {
              for (let j = 0; j < storeCartList.length; j++) {
                let cartObj = storeCartList[j]
                if(cartObj 
                  && cartObj.productStockId === rowList[i].id
                  && (cartObj.productNumber + rowList[i].defaultStock) > rowList[i].productNum
                ){
                  that.$message.error(rowList[i].productName + " 加购的图书数量(包括购物车中的)大于当前库存");
                  return false
                }
              }
            }
            let proParams = {};
            proParams.id = rowList[i].id;
            proParams.productNum = rowList[i].defaultStock;
            params.push(proParams);
          }
        }
        if(params.length == 0){
          that.$message({message: "加入购物车图书数量不能为0！", type: "warning",});
          return;
        }

        let user_id = that.$store.state.userInfo.id;
        postAction(that.url.addCart, {
          params: JSON.stringify(params),
          userId: user_id,
        })
          .then((res) => {
            if (res.data.success) {
              that.$message({message: "加入购物车成功！", type: "success",});
              that.getCartItems();
              if (addFlag == 'all') {
                that.dialogTableVisible = false;
              }
            }
          })
          .finally(() => {
            that.loading = false;
          });
        // setTimeout(() => {
        //   this.getCartItems();
        // }, 500);
      } else {
        that.$message({message: "未选择任何商品，无法添加购物车", type: "warning",});
      }
    },
    showStockList(item) {
      console.log("showStockList=======",item);
      // if(item.isBan == 0){
      //   this.$message.error("该书为违禁图书，不能购买！");
      //   return;
      // }
      this.dialogTableVisible = true;
      this.dialogTitle = "图书库存选择-ISBN:" + item.sn + "  定价:￥" + item.marketPrice;
      getAction(this.url.queryProductsStockListBySn, {
        sn: item.sn,
        marketPrice: item.marketPrice,
        whUId: this.$store.state.userInfo.id
      }).then((ret) => {
        console.log("ret :>> ", ret);
        if (ret.data.success) {
          this.gridData = ret.data.result;
        }
      });
    },
    getCartItems() {
      //获取购物车信息,并存入vuex
      getAction(this.url.queryCartList, {
        uid: this.$store.state.userInfo.id,
      }).then((ret) => {
        console.log("ret :>> ", ret);
        if (ret.data.success) {
          this.$store.state.shopCart = ret.data.result;
          window.sessionStorage.setItem("shopCart", JSON.stringify(ret.data.result));
        }
      });
    },
    goBuy() {
      let id = this.$route.params.id;
      this.$router.push(`/detail/${id}`);
    },
    closeVideo() {
      this.showSlide = "slideUp";
      setTimeout(() => {
        this.showSlide = "";
      }),
        600;
    },
    // 页面切换方法
    handleCurrentChange(val) {
      console.log("val------ :>> ", val);
      this.getGoodsList(val, this.queryParam);
      this.currentPage = val;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log("val :>> ", val);
    },
    overHidden(text, num) {
      if (text !== "" && text !== null) {
        return text.length >= 20 ? text.substr(0, num) : text;
      } else {
        return text;
      }
    },
    // 商品数量文本框改变事件
    bookAmountChange(e, item) {
      if (e.target.value <= 0) {
        item.defaultStock = 1;
        return this.$message.error("加购的图书数量不能小于0");
      }
      console.log("e.target.value :>> ", e.target.value);
      if (e.target.value > item.productNum) {
        item.defaultStock = item.productNum;
        return this.$message.error("加购的图书数量大于当前库存");
      }
    },
    // 商品数量加1
    addAmountCount(item) {
      // ++item.defaultStock;
      if (++item.defaultStock > item.productNum) {
        item.defaultStock = item.productNum;
        return this.$message.error("加购的图书数量大于当前库存");
      }
    },
    // 商品数量减1
    subtractAmountCount(item) {
      if (item.defaultStock <= 0) {
        return this.$message.error("加购的图书数量不能小于0");
      }
      --item.defaultStock;
    },
    getPath() {
      console.log("currentroute", this.$route.path);
    },
  },
  computed: {
    currHours() {
      return new Date().getHours();
    },
    ...mapGetters(["isNaName"]),
  },
};
</script>

<style lang="scss" scoped>
.container {
  // height: 580px;
  .n-main-nav {
    position: relative;
    overflow: hidden;
  }
  .el-col-12 {
    width: 100%;
  }
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.bg-purple-light {
  line-height: 36px;
  margin-top: 1%;
}
.el-divider {
  margin: 8px 0;
}
.product {
  font-size: 14px;
  font-weight: 500;
  .productinfo {
    line-height: 24px;
    font-size: 12px;
    h2 {
      font-size: 16px;
    }
    .oldprice {
      text-decoration: line-through;
      color: #f56c6c;
    }
    .disprice {
      color: #f56c6c;
    }
  }
}
.opeart {
  height: 172px;
  display: flex;
  flex-wrap: wrap;
  span {
    width: 132px;
    height: 40px;
    padding: 0 24px;
    line-height: 40px;
    font-size: 16px;
  }
  button {
    font-size: 13px;
    width: 132px;
    height: 45px !important;
    margin-block-start: auto;
  }
}
.dialog-title {
  font-size: 16px;
}
.el-dialog__header {
  border-bottom: 1px solid #1a1717 !important;
}

.el-input {
  display: flex;

  input {
    line-height: 30px;
    padding-left: 10px;
    outline: none;
  }

  .quick-button {
    i {
      display: block;
      width: 30px;
      height: 16px;
      border-left: none;
      text-align: center;
      line-height: 16px;
      cursor: pointer;
    }

    .el-icon-arrow-up {
      border-bottom: none;
    }
  }

  .quick-button i:hover {
    color: #ef001c;
  }
}
.top-tool {
  line-height: 30px;
  display: flex;
  justify-content: space-between; //两端对齐
  border: 1px solid #cccc;
  border-radius: 4px;
  background-color: #fff;
  color: #303133;
  transition: 0.3s;
  div {
    line-height: 32px;
  }
  .sort {
    ul {
      li {
        float: left;
        margin-left: 10px;
        a {
          color: #303133;
          &:hover {
            color: #409eff;
          }
        }
      }
    }
  }
}
</style>
